const isClient = typeof window !== 'undefined';
const defaultWindow = isClient ? window : undefined;
const defaultDocument = isClient ? window.document : undefined;
export { defaultDocument, defaultWindow, isClient };